<template>
    <div class="addUserAdmin">
        <div v-if="loading" class="text-center">
            <v-progress-circular class="mt-auto" :size="70" :width="7" color="primary"
                indeterminate></v-progress-circular>
        </div>

        <div v-else class="col-md-12">


            <v-form ref="form" lazy-validation class="col-sm-12 col-md-12">
                <div class="custom-row">
                    <div class="col-sm-12 col-md-5">
                        <v-text-field v-if="addUsersAdminCompanyId" color="secondary" label="*Empresa"
                            placeholder="Selecciona una Empresa" disabled
                            v-model="addUsersAdminCompanyId.name"></v-text-field>

                        <v-text-field color=secondary label="*Primer Nombre" placeholder="Ingrese el primer nombre"
                            required :counter="50" :maxlength="50" :rules="firstNameRules"
                            v-model="formData.firstName"></v-text-field>

                        <v-text-field color=secondary label="*Primer Apellido" placeholder="Ingrese el primer apellido"
                            required :counter="50" :maxlength="50" :rules="lastNameRules"
                            v-model="formData.lastName"></v-text-field>

                        <v-select color="secondary" label="*Tipo Identificación"
                            placeholder="Selecciona un tipo de identificación" required :items="typeIdentification"
                            item-text="identificationType" item-value="identificationId"
                            :rules="tipoIdentificacionRules" v-model="formData.identificationId"></v-select>

                        <v-text-field v-if="!addUsersAdminCompanyId" color=secondary label="*Correo"
                            placeholder="Ingrese un Correo" required :counter="200" :maxlength="200" :rules="emailRules"
                            v-model="formData.emailAddress"></v-text-field>

                        <v-select v-if="addUsersAdminCompanyId" color="secondary" label="*Rol"
                            placeholder="Selecciona un tipo del rol" required :items="typeRol" item-text="nameRole"
                            item-value="roleId" :disabled="true" :rules="tipoRolRules"
                            v-model="formData.roleId"></v-select>

                        <v-select color="secondary" label="*Género" placeholder="Selecciona un tipo de género" required
                            :items="affiliatedGender" item-text="gernderName" item-value="genderId" :rules="genderRules"
                            v-model="formData.genderId"></v-select>

                    </div>
                    <div class="col-sm-12 col-md-5">

                        <v-text-field v-if="addUsersAdminCompanyId" color=secondary label="*Correo"
                            placeholder="Ingrese un Correo" required :counter="200" :maxlength="200" :rules="emailRules"
                            v-model="formData.emailAddress"></v-text-field>

                        <v-text-field color=secondary label="Segundo Nombre" placeholder="Ingrese el segundo nombre"
                            :counter="50" :maxlength="50" v-model="formData.middleName"></v-text-field>

                        <v-text-field color=secondary label="Segundo Apellido" placeholder="Ingrese el segundo apellido"
                            :counter="50" :maxlength="50" v-model="formData.secondLastName"></v-text-field>

                        <v-text-field color="secondary" label="*Número Identificación"
                            placeholder="Ingrese el Número Identificación" required
                            :rules="[...idNumberRules, idNumberLengthRule]" @input="formatIdentificationNumber"
                            v-model="formData.identificationNumber" @keydown="handleKeyDown" inputmode="numeric"
                            pattern="[0-9]{19}" :counter="19" :maxlength="19"></v-text-field>

                        <v-select v-if="!addUsersAdminCompanyId" color="secondary" label="*Rol"
                            placeholder="Selecciona un tipo del rol" required :items="typeRol" item-text="nameRole"
                            item-value="roleId" :rules="tipoRolRules" v-model="formData.roleId"></v-select>

                        <v-row>
                            <v-col cols="4" md="3" sm="3">
                                <v-select color="secondary" label="*Indicativo" required :items="listGender"
                                    item-text="countryPhoneCode" item-value="countryPhoneCodeId"
                                    v-model="formData.countryPhoneCodeId"
                                    :rules="CountryPhoneCodeRules">
                                </v-select>
                            </v-col>

                            <v-col cols="8" md="9" sm="9">
                                <v-text-field color="secondary" label="*Contacto WhatsApp"
                                    placeholder="Ingrese el Contacto WhatsApp" required
                                    :rules="[...idNumberCRules, idNumberCLengthRule]"
                                    v-model="formData.cellPhoneNumber" @keydown="handleKeyDown"
                                    inputmode="numeric" pattern="[0-9]{10}" :counter="10" :maxlength="10">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </div>
                </div>
            </v-form>

        </div>
        <div class="img-btn">
            <v-tooltip left>

                <template v-slot:activator="{ on, attrs }">

                    <v-btn fab fixed bottom right dark large color="primary" v-bind="attrs" v-on="on"
                        @click="submitForm">
                        <v-icon dark>mdi-content-save</v-icon>
                    </v-btn>

                </template>

                <span>Guardar usuario</span>

            </v-tooltip>
        </div>
    </div>
</template>

<script>

import EventBus from '@/utils/event_bus.js';
import { mapActions, mapGetters } from "vuex";

import {
    COMPANIES_M,
    GET_COMPANIES,
    ACTION_GET_COMPANIES,
} from "@/views/companies/store/types/types.js";

import {
    ACTION_POST_CREATE_USERSADMIN,
    USERSADMIN_M,
    GET_STATE_LOADING,
    ACTION_GET_USERSADMIN_LIST_TYPE_DOCUMENT,
    GET_USERADMIN_LIST_TYPE_DOCUMENT,
    ACTION_GET_USERSADMIN_LIST_TYPE_ROL,
    GET_USERADMIN_LIST_TYPE_ROL,
    ACTION_GET_AFFILIATEDUSERS_LIST_GENDER,
    GET_AFFILIATEDUSERS_LIST_GENDER,
} from "@/views/users_admin/store/types/types.js";

import {
    PRODUCTS_M,
    ACTION_GET_LIST_COUNTRY,
    GET_LIST_COUNTRY
} from "@/views/products/store/types/types.js";

import Swal from "sweetalert2";

const correoRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
export default {

    components: {
    },

    name: "addUserAdmin",
    props: {
        addUsersAdminCompanyId: {
        },
    },
    data() {
        return {
            selectCompany: false,

            formData: {
                userId: null,
                firstName: null,
                middleName: null,
                lastName: null,
                secondLastName: null,
                identificationId: 1,
                emailAddress: null,
                identificationNumber: null,
                roleId: this.addUsersAdminCompanyId ? 2 : null,
                nameRole: null,
                genderId: null,
                cellPhoneNumber: null,
                countryPhoneCodeId: 1,
                isFirstUserCompany: false,
                companyId: null

            },

            firstNameRules: [
                v => !!v || "Primer Nombre requerido",
                v => (v && v.length <= 50) || "El primer nombre no puede tener más de 50 caracteres"
            ],

            lastNameRules: [
                v => !!v || "El primer apellido requerido",
                v => (v && v.length <= 50) || "El primer apellido no puede tener más de 50 caracteres"
            ],

            genderRules: [
                v => !!v || "El género requerido"
            ],

            tipoIdentificacionRules: [
                v => !!v || "Tipo identificación requerido"
            ],

            idNumberRules: [
                v => !!v || "El número identificación requerido",
            ],
            idNumberLengthRule: v =>
                (v && v.length <= 19) || "El número de identificación debe tener 19 dígitos",


            emailRules: [
                v => !!v || "El correo requerido",
                v => (v && v.length <= 200) || "El correo no puede tener más de 200 caracteres",
                v => correoRegex.test(v) || "El formato del correo es inválido"
            ],

            tipoRolRules: [
                v => !!v || "Rol requerido"
            ],

            CountryPhoneCodeRules: [
                v => !!v || "El indicativo es requerido"
            ],
            idNumberCRules: [
                v => !!v || "El contacto WhatsApp es requerido",
            ],

            idNumberCLengthRule: v =>
                (v.length === 10) || "El contacto WhatsApp debe tener 10 dígitos",

            showErrorMessages: false
        };

    },

    async mounted() {

         this.getActionTypeIdentification();
         this.getActionTypeRol();
         this.getActionCompany();
        this.agregarEmpresa();
        if (this.addUsersAdminCompanyId) {
            this.formData.isFirstUserCompany = true;
            this.formData.companyId = this.addUsersAdminCompanyId.companyId;
        }
         this.getActionListCountry();
         this.getAffiliatedGender();

    },

    methods: {
        ...mapActions({
            postCrearUsersAdmin: `${USERSADMIN_M}${ACTION_POST_CREATE_USERSADMIN}`,
            getActionTypeIdentification: `${USERSADMIN_M}${ACTION_GET_USERSADMIN_LIST_TYPE_DOCUMENT}`,
            getActionTypeRol: `${USERSADMIN_M}${ACTION_GET_USERSADMIN_LIST_TYPE_ROL}`,
            getActionCompany: `${COMPANIES_M}${ACTION_GET_COMPANIES}`,
            getActionListCountry: `${PRODUCTS_M}${ACTION_GET_LIST_COUNTRY}`,
            getAffiliatedGender: `${USERSADMIN_M}${ACTION_GET_AFFILIATEDUSERS_LIST_GENDER}`,
        }),

        formatIdentificationNumber() {
            // Eliminar puntos y espacios del número de identificación actual
            let number = this.formData.identificationNumber.replace(/[^\d]/g, '');

            // Formatear el número con puntos de unidades, decenas, centenas, etc.
            let formattedNumber = '';
            while (number.length > 0) {
                // Agregar los últimos tres dígitos al principio del número formateado
                formattedNumber = number.slice(-3) + formattedNumber;

                // Quitar los últimos tres dígitos del número
                number = number.slice(0, -3);

                // Si todavía quedan dígitos, agregar un punto al principio del número formateado
                if (number.length > 0) {
                    formattedNumber = '.' + formattedNumber;
                }
            }

            // Asignar el número formateado de vuelta al campo de texto
            this.formData.identificationNumber = formattedNumber;
        },

        agregarEmpresa() {
            try {

                if (this.addUsersAdminCompanyId.companyId) {
                    this.formData.companyId = this.addUsersAdminCompanyId.companyId;
                }
            } catch (error) {
                console.error("aldvertencia entro por crear usuario companyId");
            }

        },

        async clearForm() {
            this.formData.firstName = '';
            this.formData.middleName = '';
            this.formData.lastName = '';
            this.formData.secondLastName = '';
            this.formData.emailAddress = '';
            this.formData.identificationId = '';
            this.formData.companyId = "";
            this.formData.identificationNumber = '';
            this.formData.roleId = '';
            this.formData.genderId = '',
                this.formData.gernderName = '',
                this.formData.nameRole = '';
            this.formData.cellPhoneNumber = '';
        },

        async resetForm() {
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            this.showErrorMessages = false;

        },


        handleKeyDown(event) {
            // Permite solo números y la tecla de borrar
            if (!/^[0-9]$/.test(event.key) && event.key !== 'Backspace') {
                event.preventDefault();
            }
        },


        async submitForm() {
            try {

                if (!this.formData.cellPhoneNumber || this.formData.cellPhoneNumber.trim() === '') {
                    this.formData.cellPhoneNumber = null;
                }
                const result = await Swal.fire({
                    title: '¿Desea Guardar?',
                    icon: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Sí, guardar',
                    cancelButtonText: 'No',
                    confirmButtonColor: '#6E17A5'
                });

                if (result.isConfirmed) {
                    const validationErrors = this.validateForm();

                    if (Object.keys(validationErrors).length > 0) {
                        const errorMessages = Object.values(validationErrors).join('<br>');
                        Swal.fire({
                            icon: 'error',
                            title: 'Errores de validación',
                            html: '<div class="swal-subtitle"><b>Los siguientes campos son requeridos:</b></div><br>' + errorMessages,
                        });
                        return;
                    }

                    const save = await this.postCrearUsersAdmin(this.formData);
                    if (!save) {
                        return Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Debes diligenciar los campos'
                        });
                    }

                    // Ambas llamadas esperan a que se completen antes de continuar
                    await this.clearForm();
                    //await this.resetForm();
                    EventBus.$emit('formUserAdmin-submitted-successfully');

                } else {
                    await Swal.fire({
                        position: 'top-end',
                        icon: 'info',
                        title: 'La acción ha sido cancelada.',
                        showConfirmButton: false,
                        timer: 2500
                    });
                }


            } catch (error) {
                console.error("fallo al enviar");
            }
        }
        ,


        validateForm() {
            this.showErrorMessages = true;

            const errors = {};

            if (!this.formData.firstName || !this.formData.firstName.trim() || this.formData.firstName.length > 50) {
                errors.firstName = 'Primer Nombre';
            }

            if (this.formData.middleName && !/\S(?:.*\S)?/.test(this.formData.middleName)) {
                errors.middleName = 'Segundo Nombre no debe contener espacios en blanco';
            }

            if (!this.formData.lastName || !this.formData.lastName.trim() || this.formData.lastName.length > 50) {
                errors.lastName = 'Primer Apellido';
            }

            if (this.formData.secondLastName && !/\S(?:.*\S)?/.test(this.formData.secondLastName)) {
                errors.secondLastName = 'Segundo Apellido no debe contener espacios en blanco';
            }

            if (!this.formData.identificationId) {
                errors.identificationId = 'Tipo Identificación';
            }

            if (!this.formData.emailAddress || !correoRegex.test(this.formData.emailAddress) || this.formData.emailAddress.length > 200) {
                errors.emailAddress = 'Correo';
            }

            if (!this.formData.genderId) {
                errors.genderId = 'Género';
            }

            if (!this.formData.identificationNumber || !this.formData.identificationNumber.trim() || this.formData.identificationNumber.length > 19) {
                errors.identificationNumber = 'Número Identificación';
            }

            if (!this.formData.roleId) {
                errors.roleId = 'Rol';
            }

            if (!this.formData.cellPhoneNumber || !this.formData.cellPhoneNumber.trim() || this.formData.cellPhoneNumber.length !== 10) {
                errors.cellPhoneNumber = 'Contacto WhatsApp';
            }

            return errors;
        },

    },

    computed: {

        ...mapGetters({
            typeIdentification: [`${USERSADMIN_M}${GET_USERADMIN_LIST_TYPE_DOCUMENT}`],
            typeRol: [`${USERSADMIN_M}${GET_USERADMIN_LIST_TYPE_ROL}`],
            empresas: [`${COMPANIES_M}${GET_COMPANIES}`],
            loading: [`${USERSADMIN_M}${GET_STATE_LOADING}`],
            listGender: [`${PRODUCTS_M}${GET_LIST_COUNTRY}`],
            affiliatedGender: [`${USERSADMIN_M}${GET_AFFILIATEDUSERS_LIST_GENDER}`],
        }),
    }
};

</script>


<style lang="css" scoped>
/* Css input imagen*/

.col-md-7 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 230px;
}

addUserAdmin {
    display: flex;
    gap: 50px;
    flex-direction: row;
    justify-content: center;
}

.custom-row {
    display: flex;
    gap: 50px;
    flex-direction: row;
    justify-content: center;
}

.custom-col {
    padding-left: 5px;
    padding-right: 5px;
}

/*Resposive*/
@media screen and (max-width: 912px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 820px) {
    .col-md-7 {
        gap: 40px;
    }
}

@media screen and (max-width: 768px) {
    .col-md-7 {
        gap: 40px;
    }

    .custom-row {
        display: flex;
        gap: 20px;
        flex-direction: column;
        justify-content: center;
    }
}

@media screen and (max-width: 425px) {
    .col-md-7 {
        gap: 10px;
        display: flex;
        flex-direction: column-reverse;
    }

    .custom-row {
        display: flex;
        gap: 50px;
        flex-direction: column;
        justify-content: center;
    }
}
</style>